module.exports = __webpack_public_path__ + "img/introduce.72d12ac3.png";